import get from 'lodash/get';

import { ResumeType } from '@glass/common/modules/resumes/types';
import { workExperiencePath } from '@glass/web/modules/resumes/createSelectWorkExperienceTitle';

const getResumeExperienceTitle = (resume: ResumeType) =>
  get(resume, `${workExperiencePath(0)}.title`, '');

export default getResumeExperienceTitle;
